/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ percent: NonNullable<unknown> }} Home_V2_Percent_CompleteInputs */

const en_home_v2_percent_complete = /** @type {(inputs: Home_V2_Percent_CompleteInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.percent}% complete`)
};

const es_home_v2_percent_complete = /** @type {(inputs: Home_V2_Percent_CompleteInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.percent}% completado`)
};

/**
* | output |
* | --- |
* | "{percent}% complete" |
*
* @param {Home_V2_Percent_CompleteInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const home_v2_percent_complete = /** @type {((inputs: Home_V2_Percent_CompleteInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_V2_Percent_CompleteInputs, { locale?: "en" | "es" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_home_v2_percent_complete(inputs)
	return en_home_v2_percent_complete(inputs)
});